import { HTMLAttributes } from "react";

export default function Python(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.7716 4.593C22.1884 4.6005 20.6771 4.73512 19.3466 4.97062C15.4279 5.66287 14.7169 7.11187 14.7169 9.7845V13.3136H23.9768V14.49H11.2414C8.55039 14.49 6.19389 16.1074 5.45664 19.1854C4.60614 22.7122 4.56864 24.9135 5.45664 28.5964C6.11476 31.338 7.68676 33.291 10.3781 33.291H13.5623V29.0602C13.5623 26.0036 16.2064 23.3077 19.347 23.3077H28.5964C31.1711 23.3077 33.2261 21.1875 33.2261 18.6022V9.78487C33.2261 7.275 31.1089 5.38987 28.5964 4.971C27.0049 4.70625 25.3545 4.58587 23.7716 4.593ZM18.7639 7.43137C19.7201 7.43137 20.5016 8.22525 20.5016 9.20175C20.5016 10.1741 19.7205 10.9605 18.7639 10.9605C17.8039 10.9605 17.0265 10.1741 17.0265 9.20175C17.0261 8.22525 17.8039 7.43137 18.7639 7.43137Z"
        fill="url(#paint0_linear_2205_3814)"
      />
      <path
        d="M34.3807 14.49V18.6023C34.3807 21.7898 31.6777 24.4729 28.596 24.4729H19.3466C16.8131 24.4729 14.7169 26.6415 14.7169 29.1788V37.9969C14.7169 40.506 16.8986 41.9824 19.3466 42.702C22.2776 43.5634 25.0886 43.7194 28.596 42.702C30.927 42.0266 33.2257 40.6684 33.2257 37.9969V34.4674H23.9767V33.2906H37.8562C40.5472 33.2906 41.5507 31.4138 42.4867 28.596C43.4535 25.6954 43.4119 22.9058 42.4867 19.185C41.8215 16.5056 40.5514 14.4896 37.8562 14.4896H34.3807V14.49ZM29.1784 36.8201C30.1387 36.8201 30.9161 37.6065 30.9161 38.5796C30.9161 39.5554 30.1384 40.3493 29.1784 40.3493C28.2221 40.3493 27.441 39.5554 27.441 38.5796C27.441 37.6065 28.2221 36.8201 29.1784 36.8201Z"
        fill="url(#paint1_linear_2205_3814)"
      />
      <path
        opacity="0.444"
        d="M36.4909 44.8489C36.4909 46.1775 30.9349 47.2549 24.0817 47.2549C17.2282 47.2549 11.6722 46.1775 11.6722 44.8489C11.6722 43.5199 17.2279 42.4425 24.0817 42.4425C30.9349 42.4425 36.4909 43.5195 36.4909 44.8489Z"
        fill="url(#paint2_radial_2205_3814)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2205_3814"
          x1="3.87634"
          y1="5.69648"
          x2="25.234"
          y2="23.9102"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A9FD4" />
          <stop offset="1" stopColor="#306998" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2205_3814"
          x1="33.2696"
          y1="35.2321"
          x2="25.6104"
          y2="24.4913"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD43B" />
          <stop offset="1" stopColor="#FFE873" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_2205_3814"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(24.0316 44.78) rotate(-90) scale(2.40687 10.5802)"
        >
          <stop stopColor="#B8B8B8" stopOpacity="0.498" />
          <stop offset="1" stopColor="#7F7F7F" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  )
}
